// DeleteBlockPlugin.jsx
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { KEY_BACKSPACE_COMMAND, KEY_DELETE_COMMAND, $getSelection, $isRangeSelection } from 'lexical';
import { useEffect } from 'react';

export default function DeleteBlockPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_DELETE_COMMAND,
      () => {
        const selection = $getSelection();

        if ($isRangeSelection(selection)) {
          const node = selection.anchor.getNode();

          if (node.getKey() === 'root') return false;

          node.remove();
          return true;
        }

        return false;
      },
      1
    );
  }, [editor]);

  return null;
}